module.exports = __webpack_public_path__ + "img/pizza-box.79170137.png";